/**
 * Vantage Core API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { EligibilitySubmissionFileDetail } from './eligibilitySubmissionFileDetail';

export interface EligibilitySubmissionFile {
  id?: string;
  controlNumber?: number;
  datasetId?: string;
  filename?: string | null;
  transmitDate?: string;
  messages?: string | null;
  hasErrors?: boolean;
  isDeleted?: boolean;
  deletedBy?: string | null;
  deletedDate?: string | null;
  createdBy?: string | null;
  createdDate?: string;
  updatedBy?: string | null;
  updatedDate?: string | null;
  details?: Array<EligibilitySubmissionFileDetail> | null;
  contents?: string | null;
}
